import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Wrapper = styled.ul`
  display: flex;
  flex: 0 0 32px;
  margin-bottom: 30px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: 50px;
  overflow: hidden;
`;

export const Menu = styled.li<{ isActive: boolean }>`
  position: relative;
  width: 100%;
  list-style: none;

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate3d(0, -50%, 0);
    width: 1px;
    height: 12px;
    background-color: ${({ theme }) => theme.colors.gray400};
  }

  &:last-child {
    &::after {
      display: none;
    }
  }

  a,
  span {
    display: block;
    width: 100%;
    height: 32px;
    text-align: center;
    padding-top: 7px;
    background-color: #fff;
    padding: 0;
    border: none;
    color: ${({ theme }) => theme.colors.gray700};
    ${getFontStyle('bold150_C1')}
    line-height: 30px;

    &:active,
    &:hover,
    &:link,
    &:visited {
      color: ${({ theme }) => theme.colors.gray700};
    }
  }

  ${(props) =>
    props.isActive &&
    css`
      a,
      span {
        background-color: ${({ theme }) => theme.colors.magenta700};
        color: ${({ theme }) => theme.colors.white100};

        &:active,
        &:hover,
        &:link,
        &:visited {
          color: ${({ theme }) => theme.colors.white100};
        }
      }

      &::after {
        display: none;
      }
    `}
`;
